(() => {
function setup(){
 const root=document.querySelector('[data-rv-bag-root]');
 const config=document.getElementById('RVBagColors');
 if(!root||!config||root.dataset.rvBagReady)return;
 root.dataset.rvBagReady='true';
 const sets=JSON.parse(config.textContent);
 const first=sets[root.dataset.initialVariant];
 const names=first.names||(first.model.includes('Portofino')?['Titelbild','Rückseite','Lederdetail','Innenraum','Verschluss','Schultergurt','Maße','Tragefoto']:first.model.includes('Bellagio')?['Titelbild','Rückseite','Lederdetail','Verschluss','Henkel','Boden','Maße','Tragefoto']:first.model.includes('Amalfi')?['Titelbild','Rückseite','Seitenansicht','Innenraum','Verschluss','Henkel','Maße','Tragefoto']:['Titelbild','Vorderansicht','Lederdetail','Innenraum','Verschluss','Schulterhenkel','Maße','Tragefoto']);
 const galleries=[...root.querySelectorAll('rv-bag-gallery')];
 function apply(){
  const id=root.querySelector('form[action*="/cart/add"] input[name="id"]')?.value||root.dataset.initialVariant;
  const set=sets[id];if(!set)return;
  const complete=set.images.length===8;
  if(first.catalogSwatches||first.model.includes('Amalfi')||first.model.includes('Bellagio')||first.model.includes('Portofino')){
   root.querySelectorAll('variant-radios input[type="radio"]').forEach(input=>{
    const colorSet=Object.values(sets).find(item=>item.color===input.value);
    const label=input.labels?.[0];
    let swatch=label?.querySelector('img');
    if((first.catalogSwatches||first.model.includes('Portofino'))&&label&&colorSet?.images.length===8){
     label.classList.add('rv-bag-color-choice');
     if(!swatch){
      const caption=document.createElement('span');
      caption.textContent=input.value;
      swatch=document.createElement('img');
      swatch.width=60;swatch.height=60;swatch.loading='eager';
      label.replaceChildren(swatch,caption);
     }
    }
    if(swatch&&colorSet?.images.length===8){
     swatch.removeAttribute('srcset');swatch.src=colorSet.images[0];swatch.alt=colorSet.color;
    }
   });
  }
  root.toggleAttribute('data-rv-bag-active',complete);
  document.querySelectorAll('[data-rv-bag-story]').forEach(el=>el.hidden=!complete);
  document.querySelectorAll('[data-rv-bag-fallback]').forEach(el=>el.hidden=complete);
  document.querySelectorAll('[data-rv-bag-color]').forEach(el=>el.textContent=set.label||set.color);
  document.querySelectorAll('[data-rv-bag-width]').forEach(el=>{if(set.width)el.textContent=set.width+' cm';});
  document.querySelectorAll('[data-rv-bag-image]').forEach(img=>{
   const position=Number(img.dataset.rvBagImage)-1;
   if(!complete&&position!==7)return;
   img.removeAttribute('srcset');img.src=complete?set.images[position]:set.fallbackImage;
   img.alt=set.model+' – '+(complete?names[position]:'Produktansicht')+' – '+(set.label||set.color);
  });
  for(const gallery of galleries){
   gallery.hidden=!complete;if(!complete)continue;
   const selected=Number(gallery.dataset.selected||0);
   const hero=gallery.querySelector('[data-rv-bag-gallery-main]');
   hero.src=set.images[selected];hero.alt=set.model+' – '+names[selected]+' – '+(set.label||set.color);
   gallery.querySelectorAll('[data-rv-bag-gallery-index]').forEach((button,i)=>{
    button.querySelector('img').src=set.images[i];
    button.setAttribute('aria-label',set.model+' '+(set.label||set.color)+' – '+names[i]);
    button.setAttribute('aria-pressed',String(i===selected));
   });
  }
 }
 for(const gallery of galleries)gallery.addEventListener('click',event=>{
  const button=event.target.closest('[data-rv-bag-gallery-index]');if(!button)return;
  gallery.dataset.selected=button.dataset.rvBagGalleryIndex;apply();
 });
 root.addEventListener('change',()=>{apply();setTimeout(apply,50);setTimeout(apply,200);});
 window.addEventListener('popstate',apply);window.addEventListener('load',apply);apply();setTimeout(apply,0);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
document.addEventListener('shopify:section:load',setup);
})();